import { Alert } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const SICWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AlertStyled = styled(Alert)`
  margin-top: 2rem;
`;
